export default [
  { to: '/models/all', display: 'Models' },
  { to: '/models/gens', display: 'Generations' },
  { to: '/models/genbycountry', display: 'Country model gens' },
];
